var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('rect',{attrs:{"width":"24","height":"24","rx":"4","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }